import type { ReportsMessageId } from "./reports.fr";

/** Signalements in Dutch. Same keys and {placeholders} as reports.fr.ts. */
export const reportsNl: Record<ReportsMessageId, string> = {
  "reports.filter.severity": "Ernst",
  "reports.filter.status": "Status",
  "reports.filter.all": "Alle",
  "reports.filter.reviewOverdue": "Herbeoordeling van schorsing te laat",
  "reports.list.loading": "Meldingen laden…",
  "reports.list.loadFailed": "De meldingen konden niet worden geladen.",
  "reports.list.empty": "Geen meldingen voor deze filters.",
  "reports.list.aria": "Meldingen",
  "reports.list.by": "gemeld door {name}",
  "reports.list.aboutSubject": "{count} meldingen over deze persoon",
  "reports.pick": "Kies een melding in de lijst.",
  "reports.loading": "Melding laden…",
  "reports.loadFailed": "Deze melding kon niet worden geladen.",
  "reports.notFound": "Deze melding is niet gevonden. Laad de lijst opnieuw.",
  "reports.refreshFailed": "De melding kon niet worden vernieuwd: ze wordt getoond zoals ze was.",
  "reports.dismiss": "Sluiten",

  "reports.severity.critical": "Kritiek",
  "reports.severity.high": "Hoog",
  "reports.severity.medium": "Middel",
  "reports.severity.low": "Laag",
  "reports.status.open": "Open",
  "reports.status.investigating": "In onderzoek",
  "reports.status.decided": "Beslist",
  "reports.status.appealed": "In beroep",
  "reports.status.closed": "Gesloten",
  "reports.verdict.none": "Geen sanctie",
  "reports.verdict.warning": "Waarschuwing",
  "reports.verdict.temporary_suspension": "Tijdelijke schorsing",
  "reports.verdict.permanent_ban": "Definitieve uitsluiting",
  "reports.appeal.upheld": "Beslissing gehandhaafd",
  "reports.appeal.overturned": "Beslissing vernietigd",
  "reports.source.app": "Via de app",
  "reports.source.phone": "Per telefoon",
  "reports.source.console": "Geopend door het team",

  "reports.category.assault": "Geweld",

  "reports.new.title": "Nieuwe melding",

  "reports.new.source": "Hoe deze ons bereikte",

  "reports.new.byPhone": "Telefonisch",

  "reports.new.byStaff": "Opgemerkt door het team",

  "reports.new.subject": "Wie wordt gemeld",

  "reports.new.reporter": "Wie de melding deed",

  "reports.new.reporterHint": "Hun gebruikers-id, als een klant meldde. Laat leeg als het team het opmerkte.",

  "reports.new.category": "Wat er gebeurde",

  "reports.new.categoryHint": "De ernst volgt hieruit. Later aanpasbaar.",

  "reports.new.description": "Wat ons is verteld",

  "reports.new.descriptionHint": "Zoveel mogelijk in hun woorden. Dit leest wie onderzoekt.",

  "reports.new.submit": "Melding openen",

  "reports.new.needSubject": "Kies wie wordt gemeld.",

  "reports.new.needDescription": "Beschrijf wat er gebeurde, minstens in één zin.",

  "reports.new": "Nieuwe melding",
  "reports.category.sexual_violence": "Seksueel geweld",
  "reports.category.serious_theft": "Zware diefstal",
  "reports.category.weapon_threat": "Bedreiging met een wapen",
  "reports.category.theft": "Diefstal",
  "reports.category.threats": "Bedreigingen",
  "reports.category.harassment": "Intimidatie",
  "reports.category.fraud": "Oplichting",
  "reports.category.unsafe_work": "Onveilig werk",
  "reports.category.no_show": "Niet op de afspraak verschenen",
  "reports.category.other": "Overig",

  "reports.pill.suspended": "Geschorst",
  "reports.pill.reviewOverdue": "Herbeoordeling te laat",
  "reports.pill.legalHold": "Juridische blokkade",

  "reports.detail.versionTitle": "De getoonde versie van de melding: elke actie stuurt die mee.",
  "reports.detail.critical": "Kritieke melding",
  "reports.detail.needsPolice": "Ze is nog niet aan de politie doorgegeven. De eigenaars zijn op de hoogte gebracht.",
  "reports.detail.subject": "Gemelde persoon",
  "reports.detail.reporter": "Melder",
  "reports.detail.openedBy": "Geopend door {name}",
  "reports.detail.noReporter": "Onbekend",
  "reports.detail.job": "Gekoppelde aanvraag",
  "reports.detail.case": "Oorspronkelijk dossier",
  "reports.detail.subjectCase": "Dossier van de gemelde persoon",
  "reports.detail.openCase": "Dossier openen →",
  "reports.detail.noSubjectCase": "Geen: het wordt geopend bij een schorsing of een beroep",
  "reports.detail.none": "Geen",
  "reports.detail.description": "Wat er is gebeurd",
  "reports.detail.restrictions": "Schorsingen en uitsluitingen",
  "reports.detail.restrictionsHint":
    "Een schorsing duurt tot een beslissing van het team. De herbeoordelingstermijn is geen einde: na die termijn blijft de persoon geschorst en is de herbeoordeling te laat.",
  "reports.detail.verdict": "Uitspraak",
  "reports.detail.decidedBy": "Door {name}, op {date}",
  "reports.detail.appeal": "Beroep",
  "reports.detail.appealedAt": "Beroep ontvangen op {date}",
  "reports.detail.appealPending": "Te beslissen",
  "reports.detail.police": "Doorgiften aan de politie",
  "reports.detail.shared": "Verstrekte gegevens: {categories} · {name}, {date}",
  "reports.detail.holds": "Juridische blokkades",
  "reports.detail.holdPlaced": "Van kracht sinds {date} · {name}",
  "reports.detail.holdReleased": "Opgeheven op {date} · {name}",
  "reports.detail.related": "Andere meldingen over deze persoon",
  "reports.detail.timeline": "Tijdlijn",
  "reports.detail.actions": "Acties",
  "reports.detail.noActions": "Met uw rollen is geen actie mogelijk op deze melding.",

  "reports.restriction.interim_suspension": "Schorsing tijdens het onderzoek",
  "reports.restriction.temporary_suspension": "Tijdelijke schorsing",
  "reports.restriction.permanent_ban": "Definitieve uitsluiting",
  "reports.restriction.untilDecision": "Tot een beslissing van het team",
  "reports.restriction.untilDecisionReviewBy": "Tot een beslissing van het team · herbeoordelen vóór {date}",
  "reports.restriction.until": "Tot {date}",
  "reports.restriction.permanent": "Definitief, tenzij een beroep wordt aanvaard",
  "reports.restriction.switchedOff": "Uitgeschakeld: {features}",
  "reports.restriction.lifted": "Opgeheven op {date} door {name}",
  "reports.restriction.inForce": "Van kracht",
  "reports.restriction.ended": "Beëindigd",

  "reports.entry.report": "Melding",
  "reports.entry.evidence": "Bewijs",
  "reports.entry.severity_changed": "Ernst gewijzigd",
  "reports.entry.suspended": "Schorsing",
  "reports.entry.suspension_lifted": "Schorsing opgeheven",
  "reports.entry.verdict": "Uitspraak",
  "reports.entry.appeal": "Beroep",
  "reports.entry.appeal_decided": "Beroep beslist",
  "reports.entry.police_referral": "Doorgegeven aan de politie",
  "reports.entry.police_data_shared": "Gegevens verstrekt aan de politie",
  "reports.entry.legal_hold_placed": "Juridische blokkade ingesteld",
  "reports.entry.legal_hold_released": "Juridische blokkade opgeheven",
  "reports.entry.linked": "Koppeling toegevoegd",
  "reports.entry.suspension_withheld": "Schorsing niet toegepast",
  "reports.entry.system": "Systeem",
  "reports.entry.evidenceLink": "Stuk bekijken →",

  "reports.police.category.identity": "Identiteit",
  "reports.police.category.contact_details": "Contactgegevens",
  "reports.police.category.id_document": "Identiteitsbewijs",
  "reports.police.category.messages": "Berichten",
  "reports.police.category.job_details": "Details van de aanvraag",
  "reports.police.category.report_and_evidence": "Melding en bewijs",
  "reports.police.category.audit_log": "Auditlogboek",
  "reports.police.category.payments": "Betalingen",
  "reports.hold.entity.safety_report": "Deze melding",
  "reports.hold.entity.user": "Het account",
  "reports.hold.entity.job": "De aanvraag",
  "reports.hold.entity.conversation": "Het gesprek",

  "reports.block.ownVerdict": "U hebt de uitspraak gedaan: iemand anders moet over het beroep beslissen.",
  "reports.block.ownerOnly": "Alleen een eigenaar kan gegevens aan de politie verstrekken.",
  "reports.block.noReferral": "Geef de melding eerst door aan de politie om verstrekte gegevens te noteren.",

  "reports.action.evidence": "Bewijs toevoegen",
  "reports.action.severity": "Ernst wijzigen",
  "reports.action.suspend": "Schorsen tijdens het onderzoek",
  "reports.action.lift": "Schorsing opheffen",
  "reports.action.verdict": "Uitspraak doen",
  "reports.action.ban": "Definitief uitsluiten",
  "reports.action.appeal": "Over het beroep beslissen",
  "reports.action.police": "Doorgeven aan de politie",
  "reports.action.share": "Verstrekte gegevens noteren",
  "reports.action.hold": "Juridische blokkade instellen",
  "reports.action.release": "Juridische blokkade opheffen",

  "reports.dialog.evidence.title": "Bewijs toevoegen · {reference}",
  "reports.dialog.evidence.body": "Beschrijf het stuk en geef de link als het online staat. Het komt in de tijdlijn.",
  "reports.dialog.severity.title": "Ernst wijzigen · {reference}",
  "reports.dialog.severity.body":
    "Een kritieke melding brengt de eigenaars op de hoogte en moet aan de politie worden doorgegeven. Zeg waarom u dit wijzigt.",
  "reports.dialog.suspend.title": "Schorsen · {reference}",
  "reports.dialog.suspend.body":
    "{name} kan Walliyo niet meer gebruiken, behalve om contact op te nemen met het team en in beroep te gaan, tot een beslissing van het team. Er geldt een herbeoordelingstermijn: dat is geen einde van de schorsing. De persoon krijgt een bericht in de app en er wordt een dossier op diens naam geopend.",
  "reports.dialog.lift.title": "Schorsing opheffen · {reference}",
  "reports.dialog.lift.body": "{name} krijgt vanaf nu weer toegang tot Walliyo. Zeg waarom.",
  "reports.dialog.verdict.title": "Uitspraak doen · {reference}",
  "reports.dialog.verdict.body":
    "{name} leest de reden in de app en kan één keer in beroep gaan. Niemand krijgt een sanctie zonder schriftelijke reden.",
  "reports.dialog.ban.title": "Definitief uitsluiten · {reference}",
  "reports.dialog.ban.body":
    "{name} verliest voorgoed de toegang tot Walliyo en het identiteitsbewijs wordt uitgesloten. De reden wordt in de app getoond; één keer in beroep gaan is mogelijk.",
  "reports.dialog.appeal.title": "Over het beroep beslissen · {reference}",
  "reports.dialog.appeal.body":
    "Vernietigd heft op wat de uitspraak heeft ingesteld. {name} leest uw reden in de app. Iemand anders dan wie de uitspraak deed, moet beslissen.",
  "reports.dialog.police.title": "Doorgeven aan de politie · {reference}",
  "reports.dialog.police.body": "Noteer aan wie de melding is doorgegeven. Vanaf hier wordt niets verzonden.",
  "reports.dialog.share.title": "Gegevens verstrekt aan de politie · {reference}",
  "reports.dialog.share.body":
    "Noteer precies wat is verstrekt, categorie per categorie. Dit spoor wordt bewaard en staat in het auditlogboek.",
  "reports.dialog.hold.title": "Juridische blokkade instellen · {reference}",
  "reports.dialog.hold.body":
    "Niets wat met deze melding te maken heeft, kan worden verwijderd zolang de blokkade geldt, ook niet door de bewaarregel.",
  "reports.dialog.release.title": "Juridische blokkade opheffen · {reference}",
  "reports.dialog.release.body": "De bewaarregels gelden opnieuw voor alles wat de blokkade beschermde.",

  "reports.field.evidence": "Het bewijs",
  "reports.field.evidenceUrl": "Link (optioneel)",
  "reports.field.evidenceUrlHint": "Een https://-adres, bijvoorbeeld een foto die in het dossier is geplaatst.",
  "reports.field.severity": "Nieuwe ernst",
  "reports.field.verdict": "Uitspraak",
  "reports.field.suspendedUntil": "Geschorst tot",
  "reports.field.toldReason": "Reden die de persoon leest",
  "reports.field.toldHint": "Een echte zin, in woorden die de persoon begrijpt. Minstens 10 tekens.",
  "reports.field.decision": "Beslissing",
  "reports.field.station": "Politiebureau of brigade",
  "reports.field.officerName": "Naam van de agent",
  "reports.field.officerContact": "Contactgegevens van de agent (optioneel)",
  "reports.field.policeReference": "Referentie van de politie (optioneel)",
  "reports.field.referral": "Doorgifte",
  "reports.field.categories": "Verstrekte gegevens",
  "reports.field.shareDescription": "Wat er precies is verstrekt",
  "reports.field.shareDescriptionHint": "Bijvoorbeeld: berichten van 3 tot 5 mei, scan van de identiteitskaart.",
  "reports.field.reasonOptional": "Reden (optioneel)",

  "reports.problem.reason": "Geef een reden van {min} tot {max} tekens.",
  "reports.problem.told": "Schrijf de reden die de persoon leest: minstens {min} tekens.",
  "reports.problem.evidence": "Beschrijf het bewijs.",
  "reports.problem.url": "De link moet een volledig http://- of https://-adres zijn.",
  "reports.problem.until": "Kies een einddatum van de schorsing in de toekomst.",
  "reports.problem.police": "Vul het politiebureau en de naam van de agent in (elk 2 tot 200 tekens).",
  "reports.problem.referral": "Kies de betreffende doorgifte.",
  "reports.problem.categories": "Vink minstens één categorie verstrekte gegevens aan.",
  "reports.problem.shareDescription": "Zeg precies wat er is verstrekt.",

  "reports.done.evidence": "Bewijs toegevoegd aan {reference}.",
  "reports.done.severity": "Ernst van {reference} gewijzigd.",
  "reports.done.suspend":
    "Persoon geschorst tot een beslissing van het team ({reference}). Die heeft een bericht in de app gekregen.",
  "reports.done.lift": "Schorsing opgeheven ({reference}).",
  "reports.done.verdict": "Uitspraak vastgelegd op {reference}. De persoon heeft een bericht in de app gekregen.",
  "reports.done.ban": "Uitsluiting vastgelegd op {reference}. De persoon heeft een bericht in de app gekregen.",
  "reports.done.appeal": "Over het beroep op {reference} is beslist. De persoon heeft een bericht in de app gekregen.",
  "reports.done.police": "Doorgifte aan de politie genoteerd op {reference}.",
  "reports.done.share": "Verstrekte gegevens genoteerd op {reference}.",
  "reports.done.hold": "Juridische blokkade ingesteld op {reference}.",
  "reports.done.release": "Juridische blokkade opgeheven op {reference}.",

  "reports.error.stale":
    "Deze melding is gewijzigd terwijl u ernaar keek. Laad ze opnieuw, controleer en probeer het dan nog eens.",
  "reports.error.refused":
    "Actie geweigerd: uw rollen bevatten niet de benodigde functie. Vraag een leidinggevende om toegang.",
  "reports.error.appealRefused":
    "Geweigerd: over het beroep moet iemand anders beslissen dan wie de uitspraak deed, met HANDLE_APPEALS.",
  "reports.error.shareRefused": "Geweigerd: alleen een eigenaar kan gegevens aan de politie verstrekken.",
  "reports.error.invalid":
    "Geweigerd: de melding is niet meer in de verwachte staat, of een veld is ongeldig. Laad ze opnieuw en controleer.",
  "reports.error.outcomeUnknown":
    "Geen antwoord van de server: de actie is misschien vastgelegd. Probeer het opnieuw: dezelfde klik kan niet twee keer worden toegepast.",

  "reports.refused.wrongStatus":
    "Geweigerd: deze melding is niet meer bij die stap, de actie geldt niet meer. Laad haar opnieuw.",
  "reports.refused.alreadyRestricted": "Geweigerd: deze persoon is al geschorst door een andere melding.",
  "reports.refused.notSuspended": "Geweigerd: deze melding heeft geen lopende schorsing meer. Laad haar opnieuw.",
  "reports.refused.suspendedUntilRequired": "Een tijdelijke schorsing heeft een einddatum in de toekomst nodig.",
  "reports.refused.ownVerdict": "Geweigerd: u deed deze uitspraak, dus iemand anders moet over het beroep beslissen.",
  "reports.refused.alreadyHeld": "Op deze melding staat al een juridische blokkade. Laad haar opnieuw.",
  "reports.refused.notHeld": "Op deze melding staat geen juridische blokkade meer. Laad haar opnieuw.",
};
